/* assets/overlay.js */

if (!customElements.get('overlay-modal')) {
    customElements.define(
        'overlay-modal',
        class OverlayModal extends HTMLElement {
            constructor() {
                super();

                this.sectionId = this.dataset.sectionId;
                this.delay = parseInt(this.dataset.delay, 10) || 0;
                this.cookieName = `overlay_${this.sectionId}`;
                this.closeButtons = this.querySelectorAll('[data-overlay-close]');
                this.modalContent = this.querySelector('.section-overlay__modal');

                this.onCloseClick = this.onCloseClick.bind(this);
                this.onKeyDown = this.onKeyDown.bind(this);
            }

            connectedCallback() {
                this.closeButtons.forEach((btn) => btn.addEventListener('click', this.onCloseClick));
                document.addEventListener('keydown', this.onKeyDown);

                if (window.Shopify && Shopify.designMode) {
                    document.addEventListener('shopify:section:select', (event) => {
                        if (event.detail.sectionId === this.sectionId) {
                            this.open();
                        }
                    });

                    document.addEventListener('shopify:section:deselect', (event) => {
                        if (event.detail.sectionId === this.sectionId) {
                            this.close(false);
                        }
                    });
                }

                this.init();
            }

            disconnectedCallback() {
                this.closeButtons.forEach((btn) => btn.removeEventListener('click', this.onCloseClick));
                document.removeEventListener('keydown', this.onKeyDown);
            }

            init() {
                // Nicht automatisch öffnen, wenn autoOpen explizit deaktiviert ist (z.B. Produkt-Benachrichtigung)
                if (this.dataset.autoOpen === 'false') {
                    return;
                }

                // Im Theme Editor nicht automatisch öffnen, sondern nur bei Fokus/Auswahl der Section
                if (window.Shopify && Shopify.designMode) {
                    return;
                }

                const isClosedCookie = this.getCookie(this.cookieName);
                if (isClosedCookie) {
                    return;
                }

                setTimeout(() => {
                    this.open();
                }, this.delay * 1000);
            }

            show(opener) {
                this.openedBy = opener;
                this.open();
            }

            open() {
                this.removeAttribute('hidden');
                // Force reflow for CSS transition
                void this.offsetWidth;
                this.classList.add('section-overlay--open');
                this.setAttribute('aria-hidden', 'false');

                const focusable = this.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                if (focusable) {
                    focusable.focus();
                }
            }

            close(setCookie = true) {
                this.classList.remove('section-overlay--open');
                this.setAttribute('aria-hidden', 'true');

                if (setCookie) {
                    // Set cookie for 24 hours (86400 seconds)
                    this.setCookie(this.cookieName, 'closed', 86400);
                }

                if (this.openedBy) {
                    this.openedBy.focus();
                    this.openedBy = null;
                }

                setTimeout(() => {
                    if (!this.classList.contains('section-overlay--open')) {
                        this.setAttribute('hidden', '');
                    }
                }, 300);
            }

            onCloseClick(event) {
                event.preventDefault();
                const setCookie = !(window.Shopify && Shopify.designMode);
                this.close(setCookie);
            }

            onKeyDown(event) {
                if (event.key === 'Escape' && this.classList.contains('section-overlay--open')) {
                    const setCookie = !(window.Shopify && Shopify.designMode);
                    this.close(setCookie);
                }
            }

            getCookie(name) {
                const value = `; ${document.cookie}`;
                const parts = value.split(`; ${name}=`);
                if (parts.length === 2) {
                    return parts.pop().split(';').shift();
                }
                return null;
            }

            setCookie(name, value, maxAgeSeconds) {
                document.cookie = `${name}=${value}; max-age=${maxAgeSeconds}; path=/; SameSite=Lax`;
            }
        }
    );

    document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-overlay-open], [data-overlay-trigger]');
        if (trigger) {
            event.preventDefault();
            const targetSelector = trigger.dataset.overlayTarget || trigger.getAttribute('data-modal');
            let overlay = null;
            if (targetSelector) {
                overlay = document.querySelector(targetSelector);
            }
            if (!overlay) {
                overlay = document.querySelector('overlay-modal.section-overlay--product-notification, overlay-modal[id^="ProductNotificationOverlay"]');
            }
            if (!overlay) {
                overlay = document.querySelector('overlay-modal[data-has-app-block="true"], overlay-modal.section-overlay--has-app');
            }
            if (!overlay) {
                const allOverlays = document.querySelectorAll('overlay-modal');
                for (const item of allOverlays) {
                    if (item.querySelector('.shopify-block, .shopify-app-block, [class*="shopify-app"], [class*="shopify-forms"], shopify-form')) {
                        overlay = item;
                        break;
                    }
                }
            }
            if (!overlay) {
                overlay = document.querySelector('overlay-modal');
            }
            if (overlay) {
                if (typeof overlay.show === 'function') {
                    overlay.show(trigger);
                } else if (typeof overlay.open === 'function') {
                    overlay.open();
                }
            }
        }
    });
}
